<div class="modal-header sg-rounded-top d-flex p-0">
    <div class="w-100 sg-color__primary d-flex -content-align h-100">
        <div class="d-flex align-self-center w-100">
            <ng-content select="[header]"></ng-content>
        </div>
    </div>
    <div class="modal-close justify-content-center h-100 sg-rounded-top-right m-3">
        <div class="d-flex align-self-center">
            <mlp-ng-icon (click)="modService.dismiss()" class="cursor" name="close" size=""></mlp-ng-icon>
        </div>
    </div>
</div>

<div class="modal-body sg-rounded-bottom">
    <ng-content select="[body]"></ng-content>
</div>

<div *ngIf="!hideFooter" class="modal-footer sg-rounded-bottom">
    <ng-content select="[footer]"></ng-content>
</div>